// Etat de session CPS pour la fenetre de saisie du PIN (conformite : PIN jamais stocke).
// La decision "faut-il demander le PIN" est prise a la demande via le statut cryptoki
// de la carte (service pinCps -> action native StatutCPS), pas via un etat persistant.
export default {
    namespaced: true,
    state: () => ({
        pinDialogVisible: false,
    }),
    mutations: {
        setPinDialogVisible(state, v) { state.pinDialogVisible = !!v; },
    },
    getters: {
        getPinDialogVisible: (state) => state.pinDialogVisible,
    },
};
